/*!
=========================================================
* 入金管理（入金ファイル読込）
=========================================================
*/
import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Table,
  Row,
  Col,
  Modal, ModalBody, ModalFooter,
  Input
} from "reactstrap";

import InputText from '../FormParts/InputText';
import InputSelect from '../FormParts/InputSelect';
import InputRadio from '../FormParts/InputRadio';
import InputFile from '../FormParts/InputFile';
import Request from '../../common/Request';
import SystemInfo from '../ViewParts/SystemInfo';
import {
  cst_prefecture,
  cst_supplier_type
} from '../../variables/codes_map';

import CustomTd from '../ViewParts/CustomTd';
import WithRole from '../FormParts/ButtonWithRole';
import { getErrorCodes } from "../../variables/message";
import InputCheckBox from "../FormParts/InputCheckBox";
import ReactTable from "react-table-legacy";
import moment from 'moment/moment'
import Format from '../../common/Format';
import FormatCode from '../../common/FormatCode';
import Definition from '../../common/Definition';
import { DialogSearchInvoice } from './List'
import {
  cst_deposit_collect_type
} from '../../variables/codes_map';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { sortByNumber } from "../../common/Sort"

const domain = "";

class Regist extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      valid: true,
      regist_modal: false,
      error_modal: false,
      presave_modal: false,
      supplier_id: "",
      data : {
        values : {}
      },
      tableData: [],
      csvArray: [],
      post_data: {},
      error: {},
      view: false,
      requiredCheck:{},
      column : this.default_column,
      result_column : this.result_column,
      deposit_file : null,
      customerBranchList : [],
      totalCount : 0,
      resultCount : 0,
      errorCount : 0,
      uploadStatus : 0,  // 0:アップ前、1：アップエラー、2：アップ正常、3:取込済
      dialogSearchInvoiceData : {
        values:{},
        errors:{},
        requiredData:{}
      },
      depositedDataList:[],
      oldDepositedDataList:[],
      paging:{
        "index": 0,
        "limit": 50
      },
      search_url: '/api/deposit/unlimit',
      copied: false,
      errorText : ""
    };

    this.toggleRegistModal = this.toggleRegistModal.bind(this);
    this.togglePresaveModal = this.togglePresaveModal.bind(this);
    this.validateCallback = this.validateCallback.bind(this);
    this.setDialogData = this.setDialogData.bind(this)
    this.resetDialogData = this.resetDialogData.bind(this);
    this.search = this.search.bind(this);
    this.search_count = this.search_count.bind(this)
    this.dialogSearchInvoice = React.createRef();
  }

  default_column = [
    { Header: '顧客情報',accessor: '___JOIN_client_master_deposit',headerClassName:'text-center',className:'text-left text-top',width:280,minWidth:50},
    { Header: '口座情報',accessor: '___JOIN_invoice_bank',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50},
    { Header: '入金日',accessor: 'DEPOSIT__deposit_collect_date',headerClassName:'text-center',className:'text-left text-top',width:180,minWidth:50},
    { Header: '入金金額',accessor: 'DEPOSIT__deposit_collect_amt',headerClassName:'text-center',className:'text-left text-top',width:140,minWidth:50, sortMethod: sortByNumber },
    { Header: '入金種別',accessor: 'DEPOSIT__deposit_collect_type',headerClassName:'text-center',className:'text-left text-top',width:250,minWidth:50, sortable:false},
    { Header: '結果',accessor: 'DEPOSIT__TEMP1',headerClassName:'text-center',className:'text-left text-top',width:140,minWidth:50, sortable:false},
  ];

  result_column = [
    { Header: '顧客情報',accessor: '___JOIN_client_master_deposit',headerClassName:'text-center',className:'text-left text-top',width:280,minWidth:50},
    { Header: '口座情報',accessor: '___JOIN_invoice_bank',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50},
    { Header: '入金日',accessor: 'DEPOSIT__deposit_collect_date',headerClassName:'text-center',className:'text-left text-top',width:180,minWidth:50},
    { Header: '入金金額',accessor: 'DEPOSIT__deposit_collect_amt',headerClassName:'text-center',className:'text-left text-top',width:140,minWidth:50, sortMethod: sortByNumber },
    { Header: '入金種別',accessor: 'DEPOSIT__deposit_collect_type',headerClassName:'text-center',className:'text-left text-top',width:250,minWidth:50, },
    { Header: '引き当て残高',accessor: 'DEPOSIT__TEMP2',headerClassName:'text-center',className:'text-left text-top',width:140,minWidth:50},
    { Header: 'アクション',accessor: 'actions',headerClassName:'text-center',className:'text-left text-top',width:140,minWidth:50, sortable:false},
  ];
  
  componentDidMount(){

    // CSV取込時に口座情報をチェックするため取得する
    const branch_url = "/api/customer/branch"
    Request.get(branch_url, {without_limit : true}, res => {
      this.setState({
        customerBranchList : res.Data
      });
    });
  }

  validate() {
    let message = getErrorCodes(this.state.data.errors)
    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  validateCallback(newData, callback=()=>{}){
    const data = this.state.data;
    this.setState({
      data:{
        ...data,
        ...newData
      }
    }, ()=>callback())
  }

  validateCallbackForTable(newData, prop, key){
    this.setState({
      tableData : [
        ...this.state.tableData.slice(0, key),
        {
          ...this.state.tableData[key],
          DEPOSIT__deposit_collect_type : {
            ...this.state.tableData[key].DEPOSIT__deposit_collect_type,
            props : {
              ...this.state.tableData[key].DEPOSIT__deposit_collect_type.props,
              rootData : newData
            }
          }
        },
        ...this.state.tableData.slice(key+1),
      ],
      csvArray : [
        ...this.state.csvArray.slice(0, key),
        {
          ...this.state.csvArray[key],
          deposit_collect_type : newData.values.deposit_collect_type
        },
        ...this.state.csvArray.slice(key+1),
      ]
    }, () => {
      console.log("this.state.tableData >> ", this.state.tableData)
      console.log("this.state.tableData >> ", this.state.csvArray)
    })
  }

  toggleRegistModal() {
    const params = {
      csvArray : this.state.csvArray
    }
    console.log("toggleRegistModal ", params)
    this.setState({
      regist_modal: !this.state.regist_modal
    });
  }

  togglePresaveModal() {
    this.setState({
      presave_modal: !this.state.presave_modal
    });
  }

  search_count() {
    var search_param = {}
    search_param["deposit_id"] = this.state.deposit_id;
    search_param["data_count"] = 1;
    Request.get(this.state.search_url, search_param, res => {
        // console.log(res.data);
        this.setState({data_count: res.Data});
    })
  }

  search(){
    this.search_count();
    let searchParmas = {}
    searchParmas["deposit_id"] = this.state.deposit_id;
    searchParmas["pager_index"] = "0";
    searchParmas["pager_limit"] = this.state.paging["limit"];

      Request.get(this.state.search_url, searchParmas, (res)=>{
      
      this.setState({
        selected : {}, // 検索時はチェック初期化
        tableData: this.dataMap(res.Data, this.state.uploadStatus),
        originData: res.Data,
        paging: {
          "index": parseInt(searchParmas["pager_index"]),
          "limit": parseInt(searchParmas["pager_limit"])
        },
      });
    })
  }

  regist() {
    const params = {
      csvArray : this.state.csvArray
    }
    const url = domain + '/api/deposit';
    Request.post(url, params, res => {
      const deposit_id = res.Data.map(item => (item.id)).join(" ");
      this.setState({
        uploadStatus : 3,
        deposit_id : deposit_id
      }, () => {
        this.search();
      })
    });
  }

  button_name() {
    if (this.state.view === false) {
      return "登録";
    } else {
      return "更新";
    }
  }

  set_title() {
    return "入金管理（入金ファイル読込）";
  }

  dataMap(data, uploadStatus = 2){
    const ButtonWithRole = WithRole(Button, this.props.buttons)

    return data.map((prop, key) => {
      return {
        id: key,
        ___JOIN_client_master_deposit : (<div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_client_master_deposit', prop)}} />),
        ___JOIN_invoice_bank : (<div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_invoice_bank', prop)}} />),
        DEPOSIT__deposit_collect_date : Format.format_date(prop.deposit_collect_date),
        DEPOSIT__deposit_collect_amt : Format.comma_delimited(prop.deposit_collect_amt, "円"),
        DEPOSIT__deposit_collect_type : 
        ( 
          uploadStatus === 2?
            <InputSelect
              label="入金種別"
              labelOn={false}
              name="DEPOSIT__deposit_collect_type"
              options={cst_deposit_collect_type}
              validateCallback={(newData) => this.validateCallbackForTable(newData, prop, key)}
              rootData={{
              values : { 
                deposit_collect_type : prop.deposit_collect_type }
              }}
              inTable={true} 
              isClearable={false}
            />
          :
          FormatCode.decode("cst_deposit_collect_type", prop.deposit_collect_type)
        ),
        DEPOSIT__TEMP1 : "正常",
        DEPOSIT__TEMP2: Format.comma_delimited(prop.deposit_collect_amt - prop.sum_collect_amt || 0, "円"),
        actions: (<>
          <ButtonWithRole 
            button_id="BTN_N1_02_05470"
            size="sm" 
            onClick={() => { 
              this.setDialogData(prop.id, () => {
                this.setState({
                  dialogSearchInvoiceData : {
                    values : prop
                  },
                  depositedData : this.state.depositedDataList[prop.id] || [],
                  oldDepositedData : this.state.oldDepositedDataList[prop.id] || [],
                }, () => {
                  this.dialogSearchInvoice.current.show()
                  console.log("prop.id ", prop.id)
                  console.log("depositedData ", this.state.depositedData)
                })
              })
            }} 
            className="text-center">{`引き当て設定`}
            </ButtonWithRole>
          </>
        ),
        ...prop
      }
    });
  }
  mapCSVToArray(csv){
    let uploadStatus = 2;
    const csvObject = csv.split('\n').slice(1).map((row, index) => {
      const rowData = row.split(',')

      // すべて空項目の場合は無視する（CSV作成用エクセルからカンマだけのデータが入ってくるため）
      let isAllEmpty = true;
      rowData.forEach((item) => {
        const checkStr = item.replace(/\r?\n/g,'');
        if(checkStr.trim() !== ""){
          isAllEmpty = false;
        }
      })
      if(isAllEmpty){
        return null
      }

      const customer_name = rowData[0];
      const customer_branch_name = rowData[1];

      const invoice_bank_name = rowData[2];
      const invoice_bank_branch_name = rowData[3];
      const invoice_bank_account_kana = rowData[4];
      const invoice_bank_account_type = rowData[5];
      const invoice_bank_account_number = rowData[6];
      const deposit_collect_date = rowData[7];
      const deposit_collect_amt = rowData[8];
      const deposit_collect_type_name = rowData[9];
      const deposit_collect_type = rowData[10] ? rowData[10].trim() : null;
      
      let customerBranchInfo = {}
      if(customer_branch_name.trim() === ""){
        customerBranchInfo = this.state.customerBranchList.find((branch) => (
          branch.customer_name == customer_name 
          && branch.invoice_bank_name == invoice_bank_name 
          && branch.invoice_bank_branch_name == invoice_bank_branch_name 
          && branch.invoice_bank_account_kana == invoice_bank_account_kana 
          && branch.invoice_bank_account_type == invoice_bank_account_type 
          && branch.invoice_bank_account_number == invoice_bank_account_number))
      } else {
        customerBranchInfo = this.state.customerBranchList.find((branch) => (
          branch.customer_name == customer_name 
          && branch.customer_branch_name == customer_branch_name 
          && branch.invoice_bank_name == invoice_bank_name 
          && branch.invoice_bank_branch_name == invoice_bank_branch_name 
          && branch.invoice_bank_account_kana == invoice_bank_account_kana 
          && branch.invoice_bank_account_type == invoice_bank_account_type 
          && branch.invoice_bank_account_number == invoice_bank_account_number))  
      }
      // 口座情報が一致しない場合エラー
      if(!customerBranchInfo){
        uploadStatus = 1;
        return {error : `${index + 1}行：銀行情報に紐づく顧客が存在しません`}
      }

      // 行の項目数が合わない場合エラー
      if(rowData.length !== 11){
        uploadStatus = 1;
        return {error : `${index + 1}行：項目数が一致しません。正常「11」項目（「${rowData.length}」項目）`}
      }

      // トリム結果が空文字の場合エラーとする
      // 顧客支店名はから入力可能のため除外する
      let isEmpty = false;
      rowData.forEach((item, index) => {
        const checkStr = item.replace(/\r?\n/g,'');

        if(index !== 1 && checkStr.trim() === ""){
          isEmpty = true
        }
      })
      if(isEmpty){
        uploadStatus = 1;
        return {error : `${index + 1}行：空の項目があります`}
      }

      // 入金日チェック
      if(!this.dateCheck(deposit_collect_date)){
        uploadStatus = 1;
        return {error : `${index + 1}行：入金日が不正です（入力値：${deposit_collect_date}）`}
      }

      // 入金額チェック
      const rx = new RegExp('^(-?[0-9]{0,8}|100000000|-100000000)$');
      if(!rx.test(deposit_collect_amt)){
        uploadStatus = 1;
        return {error : `${index + 1}行：入金額が不正です。最小値：-100,000,000〜最大値：100,000,000（入力値：${deposit_collect_amt}）`}
      }

      // 入金種別チェック
      const rxType = new RegExp('^[0-7]$');
      if(!rxType.test(deposit_collect_type)){
        uploadStatus = 1;
        return {error : `${index + 1}行：入金種別が不正です。最小値：0〜最大値：7（入力値：${deposit_collect_type}）`}
      }

      return {
        customer_id : customerBranchInfo.customer_id,
        customer_name : customerBranchInfo.customer_name,
        customer_branch_id : customerBranchInfo.id,
        customer_branch_name : customer_branch_name === "" ? undefined : customerBranchInfo.customer_branch_name,
        invoice_bank_name : invoice_bank_name,
        invoice_bank_branch_name : invoice_bank_branch_name,
        invoice_bank_account_kana : invoice_bank_account_kana,
        invoice_bank_account_type : invoice_bank_account_type,
        invoice_bank_account_number : invoice_bank_account_number,
        deposit_collect_customer_branch_flag : customer_branch_name === "" ? 0 : 1,
        deposit_collect_date : moment(deposit_collect_date).format("YYYY-MM-DDTHH:mm:ss"),
        deposit_collect_amt : deposit_collect_amt,
        deposit_collect_type_name : deposit_collect_type_name,
        deposit_collect_type : deposit_collect_type,
      }
    });

    // フラグ設定
    this.setState({
      uploadStatus: uploadStatus
    })
    
    return csvObject;
  }

  dateCheck(strDate) {
    if(!strDate.match(/^\d{4}\/(0?[1-9]|1[012])\/(0?[1-9]|[12][0-9]|3[01])$/)){
      return false;
    }
    var y = strDate.split("/")[0];
    var m = strDate.split("/")[1] - 1;
    var d = strDate.split("/")[2];
    var date = new Date(y,m,d);
    if(date.getFullYear() != y || date.getMonth() != m || date.getDate() != d){
      return false;
    }
    return true;
  }

  readFileAsText(file){
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = () => reject(reader.error);
      reader.onload = () => resolve((reader.result) || '');
      reader.readAsText(file);
    });
  }

  setDialogData(deposit_id, callback = () => {}){
    const params = {
      deposit_id : deposit_id
    }

    Request.get("/api/accountsreceivable/detail", params, res => {
      Request.get("/api/oldreceivable/detail", params, oldRes => {

        this.setState({
          depositedDataList : {
            [deposit_id] : res.Data
          },
          oldDepositedDataList : {
            [deposit_id] : oldRes.Data
          }
        }, () => callback())
      });
    });
  }

  resetDialogData(){
    this.setState({
      dialogSearchInvoiceData : {
        values:{},
        errors:{},
        requiredData:{}
      }
    })
  }

  render() {
    const ButtonWithRole = this.ButtonWithRole || WithRole(Button, this.props.buttons, this.state.view?this.state.data.values:undefined)
    const errorObj = this.state.csvArray.filter(error => error)
    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardBody>
                  <CardHeader>
                    <CardTitle tag="h3">{this.set_title()}</CardTitle>
                  </CardHeader>
                  <Col md="12">入金ファイル読込</Col>
                  <Col>
                    <InputFile
                      id="csvFile"
                      label='ファイル選択'
                      name='FILE__deposit_file'
                      validateCallback={this.validateCallback}
                      rootData={this.state.data}
                      validateType="regist"
                      accept=".csv"
                    />
                  </Col>
                  <Row>
                    <Col md="12">
                      <Card>
                        <CardHeader>
                          <Row>
                            <Col>
                              <ButtonWithRole 
                                button_id={"BTN_N1_02_05450"}
                                // color="info" 
                                onClick={() => { 
                                  this.props.history.push(`/deposit`)
                                }}
                              >
                                一覧に戻る
                              </ButtonWithRole>
                            </Col>
                            <Col>
                              <ButtonWithRole 
                                button_id={"BTN_N1_02_05480"}
                                disabled={this.state.uploadStatus === 3}
                                color="info" 
                                onClick={async() => { 
                                  let csvFile = document.getElementById("deposit_file");
                                  if(csvFile.files.length < 1){
                                    this.props.alertModal.current.showErrorModal({messageNo : 2478});
                                    return;
                                  }
                                  const extension = csvFile.value.split('.')[1];
                                  if(extension !== "csv"){
                                    this.props.alertModal.current.showErrorModal({messageNo : 2487});
                                    return;
                                  }
                                  const readText = await this.readFileAsText(csvFile.files[0])
                                  const csvArray = this.mapCSVToArray(readText).filter(item => item)
                                  const reault = this.dataMap(csvArray);
                                  const errorCount = csvArray.filter(item => item.error).length
                                  this.setState({
                                    tableData : reault,
                                    csvArray : csvArray,
                                    totalCount : csvArray.length,
                                    resultCount : csvArray.length - errorCount,
                                    errorCount : errorCount
                                  })
                                }}
                              >
                                CSVアップロード
                              </ButtonWithRole>
                            </Col>
                          </Row>
                        </CardHeader>
                      </Card>
                    </Col>
                  </Row>

                  {this.state.uploadStatus !== 0 && <>
                    <Row>
                      <Col md="12">
                        <Card>
                          <CardHeader>
                            <Row>
                              <Col md="9">
                                <CardTitle tag="h4">{`入金データ一覧${(this.state.uploadStatus === 1 || this.state.uploadStatus === 2) ? "（ファイル読込結果）" : ""}`}
                                </CardTitle>
                              </Col>
                              {this.state.uploadStatus !== 3 && <Col md="3">
                                <ButtonWithRole
                                  button_id={"BTN_N1_02_05460"}
                                  disabled={this.state.uploadStatus === 3 || this.state.errorCount > 0}
                                  onClick={() => {this.toggleRegistModal()}}
                                >
                                  取り込む
                                </ButtonWithRole>
                              </Col>}
                            </Row>
                          </CardHeader>
                        </Card>
                      </Col>
                    </Row>
                    {(this.state.uploadStatus === 1 || this.state.uploadStatus === 2) && <Col>総数：{this.state.totalCount}件　正常：{this.state.resultCount}件　エラー：{this.state.errorCount}件</Col>}
                    {this.state.uploadStatus === 1 && <Col style={{ color : "red" }}>結果をご確認の上、CSVを修正して、再アプロードしてください。</Col>}
                    {this.state.uploadStatus === 2 && <Col>「入金種別」を選択し、「取り込み」ボタンをクリックしてください。</Col>}
                    {this.state.uploadStatus === 3 && <Col>{this.state.resultCount}件取込完了しました。</Col>}
                    
                    <Col>
                      {/* // 0:アップ前、1：アップエラー、2：アップ正常、3:取込済 */}
                      {this.state.uploadStatus === 2 &&
                        <ReactTable
                        data={this.state.tableData}
                        columns={this.state.column}
                        minRows={2}
                        previousText="前へ"
                        nextText="次へ"
                        rowsText="件表示"
                        loadingText='読込中…'
                        noDataText='検索してください'
                        pageText=''
                        ofText='/'
                        // getTableProps={() => {
                        //   return {
                        //     style: { overflow: 'visible' }
                        //   };
                        // }}
                        getTbodyProps={() => {
                          return {
                            style: { overflow: 'visible' }
                          };
                        }}
                        getTdProps={(state, rowInfo, column) => {
                          return {
                            style: { overflow: 'visible' }
                          };
                        }}
                      />}
                      {this.state.uploadStatus === 3 &&
                        <ReactTable
                        data={this.state.tableData}
                        columns={this.state.result_column}
                        minRows={2}
                        previousText="前へ"
                        nextText="次へ"
                        rowsText="件表示"
                        loadingText='読込中…'
                        noDataText='検索してください'
                        pageText=''
                        ofText='/'
                      />}
                      <br/>
                      {this.state.uploadStatus === 1 &&
                      <>
                        <CopyToClipboard text={errorObj.filter(obj => obj.error).map(obj => obj.error).toString().replaceAll(",","\n")}
                          onCopy={() => this.setState({copied: true})}>
                          <span>
                            {errorObj.map(obj => <div>{obj.error}{obj.error && <br/>}</div>)}
                          </span>
                        </CopyToClipboard>
                      </>
                      }
                    </Col>
                  </>}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>

        {/* 登録・更新確認用モーダル */}
        <Modal isOpen={this.state.regist_modal} toggle={this.toggleRegistModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleRegistModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">{this.button_name()}</h5>
          </div>
          <ModalBody>
            <p>取込しますか？</p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleRegistModal}>
              いいえ
            </Button>
            <ButtonWithRole 
              color="info" 
              onClick={() => { 
                this.toggleRegistModal();
                this.regist(); 
              }}>
              はい
            </ButtonWithRole>
          </ModalFooter>
        </Modal>
        <DialogSearchInvoice
          ref={this.dialogSearchInvoice}
          data={this.state.dialogSearchInvoiceData}
          depositedData={this.state.depositedData}
          oldDepositedData={this.state.oldDepositedData}
          refreshCallback={this.search}
          resetDialogData={this.resetDialogData}
          negative_label="キャンセル"
          {...this.props}
        />
      </>
    );
  }
}

export default Regist;
